import { Component } from '@angular/core';
import { KeycloakService } from 'keycloak-angular';
import { EKeycloakPortalClientID } from '../../../auth/enums/keycloak-portal-client-id.enum';

@Component({
  standalone: false,
  selector: 'irembogov-privacy-policy',
  templateUrl: './irembogov-privacy-policy.component.html',
  styleUrls: ['./irembogov-privacy-policy.component.scss'],
})
export class IrembogovPrivacyPolicyComponent {
  constructor(private readonly keycloak: KeycloakService) {}
  COMPANY_TEXT =
    '<b>Company</b> (referred to as either &quot;the Company&quot;, &quot;We&quot;, &quot;Us&quot;, or &quot;Our&quot; in this Agreement) refers to Irembo Ltd, Irembo Campus KG 9 Ave, Nyarutarama, Kigali, Rwanda.';
  GET_WEBSITE_TEXT() {
    const clientId = this.keycloak.getKeycloakInstance().clientId;
    return `<b>Website</b> refers to ${
      clientId == EKeycloakPortalClientID.PRIVATE_PORTAL
        ? 'IremboPlus'
        : clientId == EKeycloakPortalClientID.ONE_STOP_CENTER_PORTAL
        ? 'One Stop Centre'
        : 'IremboGov'
    }, accessible from <a target="blank" href="https://${
      clientId == EKeycloakPortalClientID.PRIVATE_PORTAL
        ? 'iremboplus.com'
        : clientId == EKeycloakPortalClientID.ONE_STOP_CENTER_PORTAL
        ? 'onestopcentre.rdb.rw'
        : 'irembo.gov.rw'
    }">https://${
      clientId == EKeycloakPortalClientID.PRIVATE_PORTAL
        ? 'iremboplus.com'
        : clientId == EKeycloakPortalClientID.ONE_STOP_CENTER_PORTAL
        ? 'onestopcentre.rdb.rw'
        : 'irembo.gov.rw'
    }</a>`;
  }
  GET_SUPPORT_EMAIL() {
    const clientId = this.keycloak.getKeycloakInstance().clientId;
    return clientId == EKeycloakPortalClientID.ONE_STOP_CENTER_PORTAL
      ? 'onestopcenter@irembo.com'
      : 'support@irembo.com';
  }
}
